// Ensure cart drawer functionality works immediately on page load
// This is a fallback to ensure cart drawer opens even if theme.js hasn't fully loaded
(function() {
  function ensureCartDrawerWorks() {
    // Check if cart drawer element exists
    if (document.getElementById('CartDrawer')) {
      // Add click handler for cart icon as fallback
      var cartIcons = document.querySelectorAll('.bag, [data-cart-drawer-open]');
      cartIcons.forEach(function(icon) {
        // Check if handler already added
        if (icon.hasAttribute('data-cart-drawer-handler-added')) {
          return;
        }
        icon.setAttribute('data-cart-drawer-handler-added', 'true');
        
        icon.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Try to use theme.CartDrawer if available
          if (typeof theme !== 'undefined' && theme.cartDrawer && theme.cartDrawer.drawerInstance) {
            try {
              theme.cartDrawer.drawerInstance.open();
              if (theme.cartDrawer._loadCart) {
                theme.cartDrawer._loadCart();
              }
              return;
            } catch (err) {
              console.log('Theme cart drawer not ready, using fallback');
            }
          }
          
          // Fallback: manually open drawer
          var cartDrawer = document.getElementById('CartDrawer');
          var body = document.body;
          if (window.location.pathname !== '/cart') {
          if (cartDrawer) {
            body.classList.add('js-drawer-open-right');
            cartDrawer.classList.add('js-drawer-open-right');
            
            // Load cart content if possible
            if (typeof jQuery !== 'undefined' && jQuery.getJSON) {
              jQuery.getJSON('/cart.js').done(function(cart) {
                // Cart loaded, drawer will update via theme.js if available
              });
            }
          }
        }

        }, true); // Use capture phase to ensure it fires early
      });
    }
  }
  
  // Try immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureCartDrawerWorks);
  } else {
    ensureCartDrawerWorks();
  }
  
  // Also try after short delays as fallback
  setTimeout(ensureCartDrawerWorks, 100);
  setTimeout(ensureCartDrawerWorks, 500);
  setTimeout(ensureCartDrawerWorks, 1000);
})();

$(document).ready(function() {
  $(".all-categories").hover(function() {
      $("body").addClass("overlayer_menu_hover");
      $("#PageContainer").addClass("overlayer_menu_hover_2");
  },
  function() {
      $("body").removeClass("overlayer_menu_hover");
      $("#PageContainer").removeClass("overlayer_menu_hover_2");
  });
  $(".accordion-page-title").click(function(){
    if($(this).hasClass("active") == false){
      $('.accordion-page-title').removeClass("active");
      $(this).addClass("active");
      $('.accordion-page-desc').slideUp();	
      $(this).next(".accordion-page-desc").slideToggle();
    }
    else
    {
      $('.accordion-page-title').removeClass("active");
      $('.accordion-page-desc').slideUp();	
    }
  });

  // variants click slider and select image slider 
  // $('.swatch-element').on('click', function () {
  // var rawValue = $(this).find('input').val(); 
  // var numericValue = rawValue.replace(/[^0-9.]/g, ''); 
  // numericValue = Math.floor(numericValue);
  // var targetIndex = -1;
  //   $('.product-main-image .slick-slide').each(function (index) {
  //     var altText = $(this).find('img').attr('alt');
  //     if (altText == numericValue) {
  //       targetIndex = index;
  //       return false; 
  //     }
  //   });
  //   if (targetIndex >= 0) {
  //     $('.product-main-image').slick('slickGoTo', targetIndex);
  //     if ($('.product-thumb').hasClass('slick-initialized')) {
  //       $('.product-thumb').slick('slickGoTo', targetIndex);
  //     }
  //   }
  // });


// $('.single-option-selector').on('change', function () {
//   var rawValue = $(this).val(); 
//   var numericValue = rawValue.replace(/[^0-9.]/g, ''); 
//   numericValue = Math.floor(numericValue);
//   var targetIndex = -1;
//   $('.product-main-image .slick-slide').each(function (index) {
//     var altText = $(this).find('img').attr('alt');
//     if (altText == numericValue) {
//       targetIndex = index;
//       return false; 
//     }
//   });
//   if (targetIndex >= 0) {
//     $('.product-main-image').slick('slickGoTo', targetIndex);

//     if ($('.product-thumb').hasClass('slick-initialized')) {
//       $('.product-thumb').slick('slickGoTo', targetIndex);
//     }
//   }
// });


$(document).ready(function () {
  function setImageFromSelectedOption() {
    var selectedValue = $('.single-option-selector').val();
    if (!selectedValue) return;
    var numericValue = selectedValue.replace(/[^0-9.]/g, '');
    numericValue = Math.floor(numericValue);
    var targetIndex = -1;
    $('.product-main-image .slick-slide').each(function (index) {
      var altText = $(this).find('img').attr('alt');
      if (altText == numericValue) {
        targetIndex = index;
        return false;
      }
    });
    if (targetIndex >= 0) {
      $('.product-main-image').slick('slickGoTo', targetIndex);

      if ($('.product-thumb').hasClass('slick-initialized')) {
        $('.product-thumb').slick('slickGoTo', targetIndex);
      }
    }
  }
  // Run on page load
  setImageFromSelectedOption();
  // Also run when option changes
  $('.single-option-selector').on('change', function () {
    setImageFromSelectedOption();
  });

});


});

// end variants click slider and select image slider 

// slider variant checked on windowload

// var regular_price = $('.price-item--regular').attr('dataprice');
// var clean_price = regular_price?.replace(/[^0-9.]/g, '').replace(/\.00$/, '');
// clean_price = parseInt(clean_price);
// $('.swatch-element').each(function () {
//     var rawValue = $(this).find('input').val();
//     var cleanedValue = rawValue.replace(/[^0-9.]/g, '').replace(/\.00$/, '');
//     cleanedValue = parseInt(cleanedValue);
//     if (cleanedValue === clean_price) {
//         $(this).find('input').prop('checked', true);
//         $(this).siblings('.swatch-element').find('input').prop('checked', false);
//     }
// });

// whatapp icon button click js
$('.custom-whatapp-icons').on('click', function () {
  window.open(
    'https://api.whatsapp.com/send/?phone=447426727794&type=phone_number&app_absent=0',
    '_blank'
  );
});
// end whatapp button click end js



$(function() {
window.innerWidth >= 768
  ? $(".navigation-wrapper")
      .mouseenter(function() {
        $("html").addClass("active-category-nav");
      })
      .mouseleave(function() {
        $("html").removeClass("active-category-nav");
      })
  : $("html").removeClass("active-category-nav");

  $(".navigation-wrapper .all-categories .sub-item-dropdown ul.submenu.level-1 li")
    .find("ul")
    .parent()
    .addClass("parent");
});

$(window).on("load", function() {
  $(".mobile-menu").click(function() {
    $(this).toggleClass("active");
    $("html").toggleClass("nav-open");
    $("body").toggleClass("body-nav-open");
  });
});



$(document).ready(function() {
  // Unbind previously attached click event handlers

  // Attach click event handler to all-categories anchor
  $('.mobile-toggle .toggle').click(function() {
    $("html").addClass("active");
    $(".searchForm").hide();
    $(this).addClass('nav-open');
    
  }); 

  $('.mobile-toggle .close').click(function() {
      $('html').removeClass('active');
  $(".searchForm").show();
      $('.mobile-toggle .toggle').removeClass('nav-open');
  })
  $("body .mobile-toggle").on("click", function(event) {
    
        
    event.preventDefault();
    $(".sub-item-dropdown").toggleClass("menu-open");
    $(this).toggleClass("menu-active");

  });

  $(".mobile-menu").off("click").on("click", function() {
    $(this).toggleClass("active");
    $("html").toggleClass("nav-open");
    $("body").toggleClass("body-nav-open");
  });


  $("body .kuDropSortBy .kuDropdownLabel").off("click").on("click", function() {
    $(this).parent().toggleClass("active").find(".kuDropdownOptions").slideToggle("slow");
  });

  $(".site-footer__item .h4").off("click").on("click", function() {
    if (!$(this).hasClass("active")) {
      $(".site-footer__item .h4").removeClass("active");
      $(this).addClass("active");
      $(".site-footer__item .site-footer__linklist, .site-footer__item .site-footer__item-inner__address").slideUp();
      $(this).next(".site-footer__item .site-footer__linklist, .site-footer__item .site-footer__item-inner__address").slideToggle();
    } else {
      $(".site-footer__item .h4").removeClass("active");
      $(".site-footer__item .site-footer__linklist, .site-footer__item .site-footer__item-inner__address").slideUp();
    }
  });

  $(".filter-button-mobile").off("click").on("click", function() {
    $("html").addClass("active--filter--mobile");
    $(".filter-sidebar").addClass("activeFilterMobile");
  });

  $(".drawer__close-button").off("click").on("click", function() {
    $("html").removeClass("active--filter--mobile");
    $(".filter-sidebar").removeClass("activeFilterMobile");
  });  
});

// Global Cart Drawer Close Fallback - ensure close works on all pages
$(document).ready(function () {
  $(document).on('click', '[data-cart-drawer-close]', function () {
    var $cartDrawer = $('#CartDrawer');
    var $body = $('body');
    var $html = $('html');
    $body.removeClass('js-drawer-open-right');
     $html.removeClass('js-drawer-open-right');
    $cartDrawer.removeClass('js-drawer-open-right');
  });
});



// Multi Unlock Offer helpers + Cart Drawer / Cart Page functionality
window.UnlockOffers = (function() {
  function getConfiguredOffers() {
    var $script = $('#cart-drawer-unlock-offers');
    if ($script.length) {
      try {
        var offers = JSON.parse($script.html());
        if (Array.isArray(offers)) {
          return offers;
        }
      } catch (e) {
        console.error('Error parsing unlock offers config:', e);
      }
    }
    return [];
  }

  function getVendorTotal(cart, vendor) {
    var total = 0;
    if (!cart || !cart.items || !vendor) return total;
    var vendorLower = vendor.toLowerCase();
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.vendor && item.vendor.toLowerCase() === vendorLower) {
        total += item.final_line_price / 100;
      }
    }
    return total;
  }

  function isOfferInCart(cart, offer) {
    if (!cart || !cart.items || !offer) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if ((item.product_handle && item.product_handle === offer.handle) ||
          (item.handle && item.handle === offer.handle) ||
          (item.variant_id && parseInt(item.variant_id) === parseInt(offer.variantId)) ||
          (item.url && item.url.indexOf('/products/' + offer.handle) !== -1)) {
        return true;
      }
    }
    return false;
  }

  function formatMoney(amount) {
    return '£' + Number(amount).toFixed(2);
  }

  function buildDrawerSlideHtml(offer, cart) {
    var offers = getConfiguredOffers();
    var vendorTotal = getQualifyingVendorTotal(cart, offer, offers);
    var remaining = Math.max(offer.threshold - vendorTotal, 0);
    var unlockButtonHtml = '';

    if (vendorTotal >= offer.threshold) {
      unlockButtonHtml =
        '<button type="button" class="cart-drawer__unlock-offer-btn cart-drawer__unlock-offer-btn--unlock btn btn--primary" ' +
        'data-cart-drawer-unlock-button aria-label="Unlock ' + offer.vendor + ' offer">' +
        'Click here to unlock! 👈</button>';
    } else {
      // Keep exact same remaining-amount bar behaviour as original Makita offer
      unlockButtonHtml =
        '<button type="button" class="cart-page__unlock-offer-btn cart-page__unlock-offer-btn--unlock btn btn--primary Cart-Drawer" disabled>' +
        'Add ' + formatMoney(remaining) + ' More of ' + offer.vendor + ' to Unlock Your ' + (offer.unlockLabel || 'Offer') +
        '</button>';
    }

    return (
      '<div class="unlock-offers-slider__slide cart-drawer__unlock-offer" ' +
        'data-cart-drawer-unlock-offer ' +
        'data-offer-id="' + offer.id + '" ' +
        'data-offer-vendor="' + offer.vendor + '" ' +
        'data-offer-threshold="' + offer.threshold + '" ' +
        'data-offer-product-id="' + offer.variantId + '" ' +
        'data-offer-product-handle="' + offer.handle + '" ' +
        'data-offer-in-cart="false">' +
        '<div class="cart-drawer__unlock-offer-inner">' +
          '<div class="cart-drawer__unlock-offer-image">' +
            '<img src="' + (offer.bannerDrawer || '') + '" alt="' + offer.vendor + ' Unlock Offer" loading="lazy" class="unlock-offer-banner-img desktop">' +
            '<img src="' + (offer.bannerDrawerMobile || offer.bannerDrawer || '') + '" alt="' + offer.vendor + ' Unlock Offer" loading="lazy" class="unlock-offer-banner-img mobile">' +
          '</div>' +
        '</div>' +
        '<div class="cart-drawer__unlock-offer-details">' +
          '<div class="cart-drawer__unlock-offer-actions">' + unlockButtonHtml + '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function buildUnlockOffersSliderHtml(cart, context) {
    var offers = sortOffersForDisplay(cart, getConfiguredOffers());
    var slides = [];
    for (var i = 0; i < offers.length; i++) {
      var offer = offers[i];
      if (!offer.available) continue;
      if (isOfferInCart(cart, offer)) continue;
      if (context === 'drawer') {
        slides.push(buildDrawerSlideHtml(offer, cart));
      }
    }
    if (!slides.length) return '';
    var dotsHtml = slides.length > 1 ? '<div class="unlock-offers-slider__dots" data-unlock-offers-dots></div>' : '';
    return (
      '<div class="unlock-offers-slider" data-unlock-offers-slider data-slider-context="' + (context || 'drawer') + '">' +
        '<div class="unlock-offers-slider__track" data-unlock-offers-track>' + slides.join('') + '</div>' +
        dotsHtml +
      '</div>'
    );
  }

  function initUnlockOffersSliders(root) {
    var $root = root ? $(root) : $(document);
    $root.find('[data-unlock-offers-slider]').each(function() {
      var $slider = $(this);
      if ($slider.data('unlock-slider-ready')) return;
      var $track = $slider.find('[data-unlock-offers-track]');
      var $slides = $track.children('.unlock-offers-slider__slide');
      if ($slides.length <= 1) {
        $slider.data('unlock-slider-ready', true);
        return;
      }

      var $dotsWrap = $slider.find('[data-unlock-offers-dots]');
      if (!$dotsWrap.length) {
        $dotsWrap = $('<div class="unlock-offers-slider__dots" data-unlock-offers-dots></div>');
        $slider.append($dotsWrap);
      }
      $dotsWrap.empty();
      $slides.each(function(index) {
        $dotsWrap.append('<button type="button" class="unlock-offers-slider__dot' + (index === 0 ? ' is-active' : '') + '" data-unlock-slide-index="' + index + '" aria-label="Offer slide ' + (index + 1) + '"></button>');
      });

      var current = 0;
      var timer = null;

      function goTo(index) {
        current = (index + $slides.length) % $slides.length;
        $track.css('transform', 'translateX(-' + (current * 100) + '%)');
        $dotsWrap.find('.unlock-offers-slider__dot').removeClass('is-active').eq(current).addClass('is-active');
      }

      function startAuto() {
        stopAuto();
        timer = setInterval(function() {
          goTo(current + 1);
        }, 4500);
        $slider.data('unlock-slider-timer', timer);
      }

      function stopAuto() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
        var existing = $slider.data('unlock-slider-timer');
        if (existing) {
          clearInterval(existing);
          $slider.removeData('unlock-slider-timer');
        }
      }

      $dotsWrap.off('click.unlockOffersSlider').on('click.unlockOffersSlider', '[data-unlock-slide-index]', function(e) {
        e.preventDefault();
        goTo(parseInt($(this).attr('data-unlock-slide-index'), 10) || 0);
        startAuto();
      });

      $slider
        .off('mouseenter.unlockOffersSlider focusin.unlockOffersSlider mouseleave.unlockOffersSlider focusout.unlockOffersSlider')
        .on('mouseenter.unlockOffersSlider focusin.unlockOffersSlider', stopAuto)
        .on('mouseleave.unlockOffersSlider focusout.unlockOffersSlider', startAuto);
      goTo(0);
      startAuto();
      $slider.data('unlock-slider-ready', true);
    });
  }

  function itemMatchesOffer(item, offer) {
    if (!item || !offer) return false;
    if (offer.variantId && item.variant_id && parseInt(item.variant_id, 10) === parseInt(offer.variantId, 10)) {
      return true;
    }
    var handle = offer.handle;
    if (!handle) return false;
    if (item.handle === handle || item.product_handle === handle) return true;
    if (item.url && item.url.indexOf('/products/' + handle) !== -1) return true;
    return false;
  }

  function vendorsMatch(a, b) {
    return (a || '').toLowerCase() === (b || '').toLowerCase();
  }

  var LAST_VENDOR_KEY = 'unlockOfferLastActiveVendor';
  var lastActiveVendorMemory = '';

  function setLastActiveVendor(vendor) {
    if (!vendor) return;
    lastActiveVendorMemory = vendor;
    try {
      sessionStorage.setItem(LAST_VENDOR_KEY, vendor);
    } catch (e) {}
  }

  function getLastActiveVendor() {
    if (lastActiveVendorMemory) return lastActiveVendorMemory;
    try {
      lastActiveVendorMemory = sessionStorage.getItem(LAST_VENDOR_KEY) || '';
    } catch (e) {
      lastActiveVendorMemory = '';
    }
    return lastActiveVendorMemory;
  }

  function cartHasOfferVendor(cart, vendor, offers) {
    if (!cart || !cart.items || !vendor) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var matched = resolveItemOfferVendor(cart.items[i], offers);
      if (matched && vendorsMatch(matched, vendor)) return true;
    }
    return false;
  }

  /**
   * Remember unlock-offer vendor from a cart line (qty change / click).
   * Used so banner order follows the latest vendor activity, not only add order.
   */
  function rememberVendorFromLineItem($item) {
    if (!$item || !$item.length) return;
    var offers = getConfiguredOffers();
    if (!offers.length) return;

    var vendor = $item.attr('data-item-vendor') || '';
    if (vendor) {
      for (var i = 0; i < offers.length; i++) {
        if (vendorsMatch(vendor, offers[i].vendor)) {
          setLastActiveVendor(offers[i].vendor);
          return;
        }
      }
    }

    var title = (
      $item.attr('data-cart-item-title') ||
      $item.find('[data-cart-item-title]').text() ||
      $item.find('.cart-drawer__item-title span').first().text() ||
      $item.find('.cart-drawer__item-title').text() ||
      ''
    ).toLowerCase();

    for (var j = 0; j < offers.length; j++) {
      var brand = (offers[j].vendor || '').toLowerCase();
      if (!brand) continue;
      if (title.indexOf(brand) === 0 || title.indexOf(brand + ' ') !== -1) {
        setLastActiveVendor(offers[j].vendor);
        return;
      }
    }
  }

  function rememberVendorFromCartItem(item, offers) {
    offers = offers || getConfiguredOffers();
    var vendor = resolveItemOfferVendor(item, offers);
    if (vendor) setLastActiveVendor(vendor);
  }

  function sortOffersBySortOrder(offers) {
    return (offers || []).slice().sort(function(a, b) {
      var ao = Number(a && a.sortOrder);
      var bo = Number(b && b.sortOrder);
      if (isNaN(ao)) ao = 0;
      if (isNaN(bo)) bo = 0;
      return ao - bo;
    });
  }

  function isUnlockRewardItem(item, offers) {
    if (!item || !offers) return false;
    for (var o = 0; o < offers.length; o++) {
      if (itemMatchesOffer(item, offers[o])) return true;
    }
    return false;
  }

  function resolveItemOfferVendor(item, offers) {
    if (!item || !offers || !offers.length) return '';
    if (isUnlockRewardItem(item, offers)) return '';

    var itemVendor = (item.vendor || '').toLowerCase();
    var title = (item.product_title || item.title || '').toLowerCase();

    for (var j = 0; j < offers.length; j++) {
      var ov = (offers[j].vendor || '').toLowerCase();
      if (ov && itemVendor && itemVendor === ov) {
        return offers[j].vendor;
      }
    }

    // Fallback when vendor field differs but product title still carries the brand
    for (var k = 0; k < offers.length; k++) {
      var brand = (offers[k].vendor || '').toLowerCase();
      if (!brand || !title) continue;
      if (title.indexOf(brand) === 0 || title.indexOf(brand + ' ') !== -1) {
        return offers[k].vendor;
      }
    }
    return '';
  }

  /**
   * Latest Makita/Milwaukee (etc.) activity wins banner priority:
   * 1) Last qty change / add vendor (session) if still in cart
   * 2) Top visible drawer line
   * 3) First matching /cart.js line (newest-first)
   */
  function getPriorityVendorFromCart(cart, offers) {
    if (!offers || !offers.length) return '';

    var activeVendor = getLastActiveVendor();
    if (activeVendor && cartHasOfferVendor(cart, activeVendor, offers)) {
      for (var a = 0; a < offers.length; a++) {
        if (vendorsMatch(activeVendor, offers[a].vendor)) {
          return offers[a].vendor;
        }
      }
    }

    var $firstItem = $('[data-cart-drawer-items] [data-cart-item]').first();
    if ($firstItem.length) {
      var topVendor = $firstItem.attr('data-item-vendor') || '';
      var topTitle = (
        $firstItem.find('[data-cart-item-title]').text() ||
        $firstItem.find('.cart-drawer__item-title span').first().text() ||
        $firstItem.find('.cart-drawer__item-title').text() ||
        ''
      ).toLowerCase();

      for (var t = 0; t < offers.length; t++) {
        if (vendorsMatch(topVendor, offers[t].vendor)) {
          return offers[t].vendor;
        }
      }
      for (var t2 = 0; t2 < offers.length; t2++) {
        var brand = (offers[t2].vendor || '').toLowerCase();
        if (brand && (topTitle.indexOf(brand) === 0 || topTitle.indexOf(brand + ' ') !== -1)) {
          return offers[t2].vendor;
        }
      }
    }

    var items = (cart && cart.items) ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      var vendor = resolveItemOfferVendor(items[i], offers);
      if (vendor) return vendor;
    }
    return '';
  }

  function sortOffersForDisplay(cart, offers) {
    if (!offers || !offers.length) return [];
    var list = sortOffersBySortOrder(offers);
    var priorityVendor = getPriorityVendorFromCart(cart, list);
    if (!priorityVendor) return list;

    var priority = [];
    var rest = [];
    for (var i = 0; i < list.length; i++) {
      if (vendorsMatch(list[i].vendor, priorityVendor)) {
        priority.push(list[i]);
      } else {
        rest.push(list[i]);
      }
    }
    return priority.length ? priority.concat(rest) : list;
  }

  /**
   * After drawer HTML exists, force the priority vendor slide to DOM index 0
   * and reset the slider. Guards against CSS/flex and stale slider state.
   */
  function applyDrawerOfferOrder(cart, root) {
    var $scope = root ? $(root) : $(document);
    var $slider = $scope.find('[data-unlock-offers-slider][data-slider-context="drawer"]').first();
    if (!$slider.length) {
      $slider = $('[data-unlock-offers-slider][data-slider-context="drawer"]').first();
    }
    if (!$slider.length) return;

    var offers = getConfiguredOffers();
    var priorityVendor = getPriorityVendorFromCart(cart, offers);
    if (!priorityVendor) return;

    var $track = $slider.find('[data-unlock-offers-track]');
    var $slides = $track.children('.unlock-offers-slider__slide');
    if ($slides.length < 2) return;

    var $priority = $slides.filter(function() {
      return vendorsMatch($(this).attr('data-offer-vendor'), priorityVendor);
    });
    if (!$priority.length) return;

    if (!$slides.first().is($priority.first())) {
      $track.prepend($priority);
    }

    // Force slider to rebind against the new DOM order
    var oldTimer = $slider.data('unlock-slider-timer');
    if (oldTimer) clearInterval(oldTimer);
    $slider.removeData('unlock-slider-ready');
    $slider.removeData('unlock-slider-timer');
    $slider.off('.unlockOffersSlider');
    $slider.find('[data-unlock-offers-dots]').off('.unlockOffersSlider');
    initUnlockOffersSliders($slider.parent().length ? $slider.parent() : document);
  }

  function getQualifyingVendorTotal(cart, offer, allOffers) {
    var total = 0;
    var vendorLower = (offer.vendor || '').toLowerCase();
    if (!cart || !cart.items || !vendorLower) return total;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var isUnlockProduct = false;
      for (var o = 0; o < allOffers.length; o++) {
        if (itemMatchesOffer(item, allOffers[o])) {
          isUnlockProduct = true;
          break;
        }
      }
      // Unlock products do not count toward the spend threshold
      if (isUnlockProduct) continue;
      if (item.vendor && item.vendor.toLowerCase() === vendorLower) {
        total += (item.final_line_price || 0) / 100;
      }
    }
    return total;
  }

  /**
   * If qualifying vendor spend drops below an offer threshold,
   * remove that unlock product from cart, then callback(updatedCart, didRemove).
   * Pass existingCart to skip an extra /cart.js round-trip.
   */
  function enforceThresholds(done, existingCart) {
    var finish = function(cart, removed) {
      if (typeof done === 'function') done(cart || { items: [], item_count: 0 }, !!removed);
    };

    var processCart = function(cart) {
      var offers = getConfiguredOffers();
      if (!offers.length || !cart || !cart.items || !cart.items.length) {
        finish(cart, false);
        return;
      }

      var keysToRemove = [];
      offers.forEach(function(offer) {
        var offerItem = null;
        cart.items.forEach(function(item) {
          if (itemMatchesOffer(item, offer)) {
            offerItem = item;
          }
        });
        if (!offerItem) return;

        var qualifyingTotal = getQualifyingVendorTotal(cart, offer, offers);
        if (qualifyingTotal < Number(offer.threshold)) {
          keysToRemove.push(offerItem.key);
        }
      });

      keysToRemove = keysToRemove.filter(function(key, idx, arr) {
        return key && arr.indexOf(key) === idx;
      });

      if (!keysToRemove.length) {
        finish(cart, false);
        return;
      }

      // One request to clear all ineligible unlock products
      var updates = {};
      keysToRemove.forEach(function(key) {
        updates[key] = 0;
      });

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        data: { updates: updates }
      }).done(function(updatedCart) {
        finish(updatedCart, true);
      }).fail(function() {
        // Fallback: remove by line (highest first)
        var linesToRemove = [];
        cart.items.forEach(function(item, index) {
          if (keysToRemove.indexOf(item.key) !== -1) {
            linesToRemove.push(index + 1);
          }
        });
        linesToRemove.sort(function(a, b) { return b - a; });
        if (!linesToRemove.length) {
          finish(cart, false);
          return;
        }
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: { line: linesToRemove[0], quantity: 0 }
        }).done(function(updatedCart) {
          // If more remain, recurse with updated cart
          if (linesToRemove.length > 1) {
            enforceThresholds(done, updatedCart);
          } else {
            finish(updatedCart, true);
          }
        }).fail(function() {
          finish(cart, true);
        });
      });
    };

    if (existingCart && existingCart.items) {
      processCart(existingCart);
    } else {
      $.getJSON('/cart.js').done(processCart).fail(function() {
        finish(null, false);
      });
    }
  }

  function refreshCartPageOffers(cart) {
    var $slider = $('[data-unlock-offers-slider][data-slider-context="page"]');
    var offers = sortOffersForDisplay(cart, getConfiguredOffers());
    if (!cart || !cart.items || !cart.item_count) {
      $slider.remove();
      return;
    }

    var slides = [];
    offers.forEach(function(offer) {
      if (!offer.available) return;
      if (isOfferInCart(cart, offer)) return;

      var vendorTotal = getQualifyingVendorTotal(cart, offer, offers);
      var remaining = Math.max(offer.threshold - vendorTotal, 0);
      var buttonHtml = '';
      if (vendorTotal >= offer.threshold) {
        buttonHtml =
          '<button type="button" class="cart-page__unlock-offer-btn cart-page__unlock-offer-btn--unlock btn btn--primary" data-cart-page-unlock-button aria-label="Unlock ' + offer.vendor + ' offer">Click here to unlock! 👈</button>';
      } else {
        buttonHtml =
          '<button type="button" class="cart-page__unlock-offer-btn cart-page__unlock-offer-btn--unlock btn btn--primary Cart" disabled>' +
          'Add ' + formatMoney(remaining) + ' More of ' + offer.vendor + ' to Unlock Your ' + (offer.unlockLabel || 'Offer') +
          '</button>';
      }

      slides.push(
        '<div class="unlock-offers-slider__slide cart-page__unlock-offer" data-cart-page-unlock-offer data-offer-id="' + offer.id + '" data-offer-vendor="' + offer.vendor + '" data-offer-threshold="' + offer.threshold + '" data-offer-product-id="' + offer.variantId + '" data-offer-product-handle="' + offer.handle + '" data-offer-in-cart="false">' +
          '<div class="cart-page__unlock-offer-inner">' +
            '<div class="cart-page__unlock-offer-image">' +
              '<img src="' + (offer.bannerPageDesktop || offer.bannerDrawer) + '" alt="" class="unlock-offer-banner-img desktop" loading="lazy">' +
              '<img src="' + (offer.bannerPageMobile || offer.bannerDrawer) + '" alt="" class="unlock-offer-banner-img mobile" loading="lazy">' +
            '</div>' +
            '<div class="cart-page__unlock-offer-details"><div class="cart-page__unlock-offer-actions">' +
              buttonHtml +
              '<button type="button" class="unlock-offer-box__more-info btn btn--tertiary" data-offer-info-drawer-open data-offer-vendor="' + String(offer.id || offer.vendor || '').toLowerCase() + '">More Information</button>' +
            '</div></div>' +
          '</div>' +
        '</div>'
      );
    });

    var html = '';
    if (slides.length) {
      html =
        '<div class="unlock-offers-slider unlock-offers-slider--cart-page" data-unlock-offers-slider data-slider-context="page">' +
          '<div class="unlock-offers-slider__track" data-unlock-offers-track>' + slides.join('') + '</div>' +
          (slides.length > 1 ? '<div class="unlock-offers-slider__dots" data-unlock-offers-dots></div>' : '') +
        '</div>';
    }

    if ($slider.length) {
      if (html) {
        $slider.replaceWith(html);
      } else {
        $slider.remove();
      }
    } else if (html) {
      var $lineItems = $('[data-cart-line-items]');
      if ($lineItems.length) {
        $lineItems.before(html);
      }
    }
    initUnlockOffersSliders(document);
  }

  return {
    getConfiguredOffers: getConfiguredOffers,
    getVendorTotal: getVendorTotal,
    getQualifyingVendorTotal: getQualifyingVendorTotal,
    isOfferInCart: isOfferInCart,
    itemMatchesOffer: itemMatchesOffer,
    formatMoney: formatMoney,
    buildUnlockOffersSliderHtml: buildUnlockOffersSliderHtml,
    sortOffersForDisplay: sortOffersForDisplay,
    applyDrawerOfferOrder: applyDrawerOfferOrder,
    setLastActiveVendor: setLastActiveVendor,
    rememberVendorFromLineItem: rememberVendorFromLineItem,
    rememberVendorFromCartItem: rememberVendorFromCartItem,
    initUnlockOffersSliders: initUnlockOffersSliders,
    enforceThresholds: enforceThresholds,
    refreshCartPageOffers: refreshCartPageOffers
  };
})();

$(document).ready(function() {
  UnlockOffers.initUnlockOffersSliders();

  // Qty / line activity → banner priority follows that vendor
  $(document).on('click', '[data-cart-item-increase], [data-cart-item-decrease]', function() {
    UnlockOffers.rememberVendorFromLineItem($(this).closest('[data-cart-item]'));
  });

  $(document).on('change', '[data-cart-item-quantity], [data-quantity-input]', function() {
    UnlockOffers.rememberVendorFromLineItem($(this).closest('[data-cart-item]'));
  });

  $(document).on('click', '.js-qty__adjust', function() {
    UnlockOffers.rememberVendorFromLineItem($(this).closest('[data-cart-item], .cartline'));
  });

  $(document).on('ajaxCart:added', function(evt, cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    // Newest line is typically first in Ajax cart
    UnlockOffers.rememberVendorFromCartItem(cart.items[0]);
  });

  // Cart page: re-apply banner order from last qty/add vendor after Liquid paint
  if (window.location.pathname === '/cart') {
    Shopify.getCart(function(cart) {
      if (UnlockOffers.refreshCartPageOffers) {
        UnlockOffers.refreshCartPageOffers(cart);
      }
    });
  }

  // Handle unlock button click in cart drawer
  $(document).on('click', '[data-cart-drawer-unlock-button]', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    var $button = $(this);
    var $unlockOffer = $button.closest('[data-cart-drawer-unlock-offer]');
    var variantId = $unlockOffer.attr('data-offer-product-id');
    var isInCart = $unlockOffer.attr('data-offer-in-cart') === 'true';
    
    if ($button.hasClass('loading') || isInCart) {
      return false;
    }
    
    $button.addClass('loading').prop('disabled', true);
    var originalText = $button.text();
    $button.text('Adding...');
    
    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      data: {
        id: variantId,
        quantity: 1
      },
      success: function() {
        $unlockOffer.remove();
        var $slider = $('[data-unlock-offers-slider][data-slider-context="drawer"]');
        if ($slider.length && !$slider.find('[data-cart-drawer-unlock-offer]').length) {
          $slider.remove();
        } else {
          UnlockOffers.initUnlockOffersSliders();
        }
        // Fast refresh: use theme cart drawer render if available
        if (theme.cartDrawer && typeof theme.cartDrawer._loadCartAfterUnlockCheck === 'function') {
          theme.cartDrawer._loadCartAfterUnlockCheck();
        } else {
          Shopify.getCart(function(cart) {
            $(document).trigger('ajaxCart:added', cart);
          });
        }
      },
      error: function(xhr) {
        $button.removeClass('loading').prop('disabled', false).text(originalText);
        var errorMessage = 'Failed to add product to cart. Please try again.';
        if (xhr.responseJSON && xhr.responseJSON.description) {
          errorMessage = xhr.responseJSON.description;
        }
        alert(errorMessage);
      }
    });
    
    return false;
  });

  // Cart Page Unlock Offer Button Functionality
  $(document).on('click', '[data-cart-page-unlock-button]', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    var $button = $(this);
    var $unlockOffer = $button.closest('[data-cart-page-unlock-offer]');
    var variantId = $unlockOffer.attr('data-offer-product-id');
    var isInCart = $unlockOffer.attr('data-offer-in-cart') === 'true';
    
    if ($button.hasClass('loading') || isInCart) {
      return false;
    }
    
    $button.addClass('loading').prop('disabled', true);
    var originalText = $button.text();
    $button.text('Adding...');
    
    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      data: {
        id: variantId,
        quantity: 1
      },
      success: function() {
        // Keep one reload so discounted unlock pricing/line items stay correct
        window.location.reload();
      },
      error: function(xhr) {
        $button.removeClass('loading').prop('disabled', false).text(originalText);
        var errorMessage = 'Failed to add product to cart. Please try again.';
        if (xhr.responseJSON && xhr.responseJSON.description) {
          errorMessage = xhr.responseJSON.description;
        }
        alert(errorMessage);
      }
    });
    
    return false;
  });

  // Rebuild drawer unlock offers based on cart state (theme.js also renders on full rebuild)
  function updateUnlockOfferVisibility(cart) {
    var $content = $('[data-cart-drawer-content]');
    if (!$content.length) return;

    $content.find('[data-unlock-offers-slider][data-slider-context="drawer"], [data-cart-drawer-unlock-offer]').remove();

    if (!cart || !cart.items || cart.items.length === 0 || cart.item_count === 0) {
      return;
    }

    var sliderHtml = UnlockOffers.buildUnlockOffersSliderHtml(cart, 'drawer');
    if (!sliderHtml) return;

    var $form = $content.find('[data-cart-drawer-form]');
    if ($form.length) {
      $form.before(sliderHtml);
    } else {
      $content.prepend(sliderHtml);
    }
    UnlockOffers.initUnlockOffersSliders($content);
    if (typeof UnlockOffers.applyDrawerOfferOrder === 'function') {
      UnlockOffers.applyDrawerOfferOrder(cart, $content);
    }
  }

  var previousCartItemCount = 0;
  var unlockObserverTimer = null;

  $(document).on('ajaxCart:added', function(evt, cart) {
    // Theme drawer already re-renders; only patch success message quickly
    previousCartItemCount = (cart && cart.item_count) || previousCartItemCount;
    setTimeout(function() {
      addOfferSuccessMessageToCartDrawer(cart);
    }, 50);
  });

  var observer = new MutationObserver(function() {
    if (unlockObserverTimer) clearTimeout(unlockObserverTimer);
    unlockObserverTimer = setTimeout(function() {
      addOfferSuccessMessageToCartDrawer();
      UnlockOffers.initUnlockOffersSliders();
    }, 80);
  });

  var $cartDrawerContent = $('[data-cart-drawer-content]');
  if ($cartDrawerContent.length) {
    observer.observe($cartDrawerContent[0], {
      childList: true,
      subtree: false
    });
    
    Shopify.getCart(function(cart) {
      previousCartItemCount = cart.item_count || 0;
      updateUnlockOfferVisibility(cart);
    });
  }

  function addOfferSuccessMessageToCartDrawer(existingCart) {
    var offers = UnlockOffers.getConfiguredOffers();
    if (!offers.length) return;

    var applyMessage = function(cart) {
      if (!cart || !cart.items) return;

      var offerItemKeys = [];
      var offerVariantIds = [];

      cart.items.forEach(function(item) {
        for (var i = 0; i < offers.length; i++) {
          if (UnlockOffers.isOfferInCart({ items: [item] }, offers[i])) {
            offerItemKeys.push(item.key);
            if (item.variant_id) {
              offerVariantIds.push(item.variant_id.toString());
            }
            break;
          }
        }
      });

      if (!offerItemKeys.length) return;

      var $cartItems = $('[data-cart-drawer-items] [data-cart-item], .cart-drawer__item[data-cart-item]');
      if (!$cartItems.length) return;

      $cartItems.each(function() {
        var $item = $(this);
        var itemKey = $item.attr('data-cart-item-key') || $item.attr('data-item-key');
        var itemVariantId = $item.attr('data-variant-id') ||
                          $item.find('[data-cart-item-quantity]').attr('data-variant-id') ||
                          $item.find('input').attr('data-variant-id');

        var isOfferProduct = false;
        if (itemKey && offerItemKeys.indexOf(itemKey) !== -1) {
          isOfferProduct = true;
        } else if (itemVariantId && offerVariantIds.indexOf(itemVariantId.toString()) !== -1) {
          isOfferProduct = true;
        }

        if (!isOfferProduct) return;
        if ($item.find('.cart-offer-success-message').length) return;

        var $titleContainer = $item.find('.cart-drawer__item-title');
        var $title = $item.find('[data-cart-item-title]');
        if (!$title.length && $titleContainer.length) {
          $title = $titleContainer.find('span').first();
        }
        if (!$title.length) {
          $title = $titleContainer;
        }

        var messageHtml = '<div class="cart-offer-success-message" style="color: #27AE60; font-size: 12px; font-weight: 600; margin-top: 4px;">YOU DID IT 🎉 UNLOCKED!</div>';
        if ($title.length) {
          if ($title.is('span')) {
            $title.after(messageHtml);
          } else if ($titleContainer.length) {
            $titleContainer.append(messageHtml);
          } else {
            $title.after(messageHtml);
          }
        }
      });
    };

    if (existingCart && existingCart.items) {
      applyMessage(existingCart);
    } else {
      Shopify.getCart(applyMessage);
    }
  }
  UnlockOffers.addOfferSuccessMessageToCartDrawer = addOfferSuccessMessageToCartDrawer;

  $(document).on('click', '[data-cart-drawer-open], .bag', function() {
    setTimeout(function() {
      if (theme.cartDrawer && theme.cartDrawer._loadCart) {
        theme.cartDrawer._loadCart();
      }
    }, 50);
  });

  // Qty/remove are handled by theme CartDrawer._loadCartAfterUnlockCheck — no extra delayed fetches
});

// Product Page Unlock Offer Button Functionality
$(document).ready(function() {
  // Function to update unlock offer button state on product page
  function updateProductPageUnlockOffer(cart) {
    var $unlockOfferBoxes = $('[data-unlock-offer-box]');
    if (!$unlockOfferBoxes.length) {
      return;
    }

    $unlockOfferBoxes.each(function() {
      var $unlockOfferBox = $(this);
      var offerProductHandle = $unlockOfferBox.attr('data-offer-product-handle');
      var offerProductId = $unlockOfferBox.attr('data-offer-product-id');
      var offerVendor = ($unlockOfferBox.attr('data-offer-vendor') || 'Makita').toLowerCase();
      var offerThreshold = parseFloat($unlockOfferBox.attr('data-offer-threshold')) || 399;
      var $unlockButton = $unlockOfferBox.find('[data-unlock-offer-button]');
      var $claimedButton = $unlockOfferBox.find('.unlock-offer-box__claimed');
      var $actions = $unlockOfferBox.find('.unlock-offer-box__actions');

      if (!offerProductHandle || !offerProductId) {
        return;
      }

      var isInCart = false;
      var vendorTotal = 0;

      if (cart && cart.items && cart.items.length > 0) {
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if ((item.product_handle && item.product_handle === offerProductHandle) ||
              (item.handle && item.handle === offerProductHandle) ||
              (item.variant_id && parseInt(item.variant_id) === parseInt(offerProductId))) {
            isInCart = true;
          }
          if (item.vendor && item.vendor.toLowerCase() === offerVendor) {
            vendorTotal += item.final_line_price / 100;
          }
        }
      }

      if (!isInCart && vendorTotal >= offerThreshold) {
        if ($claimedButton.length) {
          var unlockButtonHtml = '<button type="button" class="unlock-offer-box__unlock btn btn--primary" data-unlock-offer-button aria-label="Unlock product">Unlock</button>';
          $claimedButton.replaceWith(unlockButtonHtml);
        } else if (!$unlockButton.length) {
          var unlockButtonHtmlCreate = '<button type="button" class="unlock-offer-box__unlock btn btn--primary" data-unlock-offer-button aria-label="Unlock product">Unlock</button>';
          $actions.prepend(unlockButtonHtmlCreate);
        }
        $unlockOfferBox.attr('data-offer-in-cart', 'false');
      } else {
        if ($unlockButton.length) {
          var claimedButtonHtml = '<button type="button" class="unlock-offer-box__claimed btn btn--secondary" disabled>Unlocked!</button>';
          $unlockButton.replaceWith(claimedButtonHtml);
        } else if (!$claimedButton.length) {
          var claimedButtonHtmlCreate = '<button type="button" class="unlock-offer-box__claimed btn btn--secondary" disabled>Unlocked!</button>';
          $actions.prepend(claimedButtonHtmlCreate);
        }
        $unlockOfferBox.attr('data-offer-in-cart', 'true');
      }
    });
  }
  
  // Handle unlock button click on product page
  $(document).on('click', '[data-unlock-offer-button]', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    var $button = $(this);
    var $unlockOfferBox = $button.closest('[data-unlock-offer-box]');
    var variantId = $unlockOfferBox.attr('data-offer-product-id');
    var isInCart = $unlockOfferBox.attr('data-offer-in-cart') === 'true';
    
    // Prevent multiple clicks
    if ($button.hasClass('loading') || isInCart) {
      return false;
    }
    
    // Check if cart has items before proceeding
    Shopify.getCart(function(cart) {
      // If cart is empty, open the more information drawer instead
      if (!cart || !cart.items || cart.items.length === 0 || cart.item_count === 0) {
        // Find and trigger the "More Information" drawer button
        var $moreInfoButton = $unlockOfferBox.find('[data-offer-info-drawer-open]');
        if ($moreInfoButton.length) {
          $moreInfoButton.trigger('click');
        } else {
          // Fallback: try to find drawer open button anywhere on page
          $('[data-offer-info-drawer-open]').first().trigger('click');
        }
        return false;
      }
      
      // Cart has items - proceed with unlock functionality
      // Disable button and show loading state
      $button.addClass('loading').prop('disabled', true);
      var originalText = $button.text();
      $button.text('Adding...');
      
      // Add product to cart via AJAX
      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        dataType: 'json',
        data: {
          id: variantId,
          quantity: 1
        },
        success: function(item) {
          // Replace unlock button with "Offer Claimed" button
          var claimedButtonHtml = '<button type="button" class="unlock-offer-box__claimed btn btn--secondary" disabled>Unlocked!</button>';
          $button.replaceWith(claimedButtonHtml);
          
          // Update data attribute
          $unlockOfferBox.attr('data-offer-in-cart', 'true');
          
          // Trigger cart update event
          Shopify.getCart(function(cart) {
            $(document).trigger('ajaxCart:added', cart);
            updateProductPageUnlockOffer(cart);
          });
        },
        error: function(xhr, status, error) {
          // Re-enable button on error
          $button.removeClass('loading').prop('disabled', false).text(originalText);
          
          // Show error message
          var errorMessage = 'Failed to add product to cart. Please try again.';
          if (xhr.responseJSON && xhr.responseJSON.description) {
            errorMessage = xhr.responseJSON.description;
          }
          alert(errorMessage);
        }
      });
    });
    
    return false;
  });
  
  // Check cart state on page load and update button
  Shopify.getCart(function(cart) {
    updateProductPageUnlockOffer(cart);
  });
  
  // Update button state when cart changes
  $(document).on('ajaxCart:added', function(evt, cart) {
    updateProductPageUnlockOffer(cart);
  });
  
  // Update button state when item is removed from cart
  $(document).on('ajaxCart:removed', function(evt, cart) {
    setTimeout(function() {
      Shopify.getCart(function(cart) {
        updateProductPageUnlockOffer(cart);
      });
    }, 50);
  });
  
  // Listen for cart drawer item removal
  $(document).on('click', '[data-cart-item-remove]', function() {
    var $button = $(this);
    var variantId = $button.attr('data-variant-id');
    var $unlockOfferBox = $('[data-unlock-offer-box]');
    
    if ($unlockOfferBox.length && variantId) {
      var offerProductIds = $unlockOfferBox.map(function() {
        return $(this).attr('data-offer-product-id');
      }).get();
      if (offerProductIds.indexOf(String(variantId)) !== -1 || offerProductIds.some(function(id) { return parseInt(id) === parseInt(variantId); })) {
        setTimeout(function() {
          Shopify.getCart(function(cart) {
            updateProductPageUnlockOffer(cart);
          });
        }, 100);
      }
    }
  });
  
  // Listen for cart quantity changes (including when quantity goes to 0)
  $(document).on('change', '[data-cart-item-quantity]', function() {
    var variantId = $(this).attr('data-variant-id');
    var $unlockOfferBox = $('[data-unlock-offer-box]');
    
    if ($unlockOfferBox.length && variantId) {
      var matched = false;
      $unlockOfferBox.each(function() {
        var offerProductId = $(this).attr('data-offer-product-id');
        if (offerProductId && parseInt(variantId) === parseInt(offerProductId)) {
          matched = true;
        }
      });
      if (matched) {
        setTimeout(function() {
          Shopify.getCart(function(cart) {
            updateProductPageUnlockOffer(cart);
          });
        }, 100);
      }
    }
  });
  
  // Listen for cart drawer content changes using MutationObserver
  var $cartDrawerContent = $('[data-cart-drawer-content]');
  if ($cartDrawerContent.length) {
    var cartObserverTimer = null;
    var cartObserver = new MutationObserver(function() {
      if (cartObserverTimer) clearTimeout(cartObserverTimer);
      cartObserverTimer = setTimeout(function() {
        Shopify.getCart(function(cart) {
          updateProductPageUnlockOffer(cart);
        });
      }, 100);
    });
    
    cartObserver.observe($cartDrawerContent[0], {
      childList: true,
      subtree: false
    });
  }
  
  // Also check when cart drawer is opened/closed
  $(document).on('click', '[data-cart-drawer-open], .bag, [data-cart-drawer-close]', function() {
    setTimeout(function() {
      Shopify.getCart(function(cart) {
        updateProductPageUnlockOffer(cart);
      });
    }, 100);
  });
  
  // Listen for any add to cart events (from main product form)
  $(document).on('submit', 'form[action="/cart/add"]', function() {
    setTimeout(function() {
      Shopify.getCart(function(cart) {
        updateProductPageUnlockOffer(cart);
      });
    }, 200);
  });
  
  // Lightweight periodic fallback (was 2s)
  if ($('[data-unlock-offer-box]').length) {
    var lastCartItemCount = 0;
    setInterval(function() {
      Shopify.getCart(function(cart) {
        if (cart.item_count !== lastCartItemCount) {
          lastCartItemCount = cart.item_count;
          updateProductPageUnlockOffer(cart);
        }
      });
    }, 4000);
  }
});

// ============================================================================
// Offer Product Validation - Prevent purchasing offer product alone
// ============================================================================
(function() {
  'use strict';
  
  // Get offer product identifiers (supports multiple unlock offers)
  function getOfferProductInfoList() {
    if (window.UnlockOffers && typeof UnlockOffers.getConfiguredOffers === 'function') {
      var configured = UnlockOffers.getConfiguredOffers();
      if (configured && configured.length) {
        return configured.map(function(offer) {
          return {
            variantId: offer.variantId,
            handle: offer.handle,
            vendor: offer.vendor,
            threshold: offer.threshold
          };
        });
      }
    }

    var list = [];
    $('[data-unlock-offer-box]').each(function() {
      var variantId = $(this).attr('data-offer-product-id');
      var handle = $(this).attr('data-offer-product-handle');
      if (variantId || handle) {
        list.push({
          variantId: variantId,
          handle: handle,
          vendor: $(this).attr('data-offer-vendor') || null,
          threshold: parseFloat($(this).attr('data-offer-threshold')) || null
        });
      }
    });
    if (list.length) return list;

    return [];
  }

  function getOfferProductInfo() {
    var list = getOfferProductInfoList();
    return list.length ? list[0] : { variantId: null, handle: null };
  }

  function isAnyOfferProduct(item) {
    var offers = getOfferProductInfoList();
    for (var i = 0; i < offers.length; i++) {
      if (isOfferProduct(item, offers[i])) {
        return true;
      }
    }
    return false;
  }
  
  // Check if an item is the offer product
  function isOfferProduct(item, offerInfo) {
    if (!item || !offerInfo) {
      return false;
    }
    
    if (!offerInfo.variantId && !offerInfo.handle) {
      return false;
    }
    
    // Check by variant ID (most reliable)
    if (offerInfo.variantId && item.variant_id) {
      if (parseInt(item.variant_id) === parseInt(offerInfo.variantId)) {
        return true;
      }
    }
    
    // Check by product ID (if available)
    if (offerInfo.variantId && item.product_id) {
      // Get product ID from variant ID if possible, or check directly
      // This is a fallback check
    }
    
    // Check by product handle (fallback)
    if (offerInfo.handle) {
      // Check product_handle property
      if (item.product_handle && item.product_handle === offerInfo.handle) {
        return true;
      }
      
      // Check handle property (alternative)
      if (item.handle && item.handle === offerInfo.handle) {
        return true;
      }
      
      // Check by product handle from URL (another fallback)
      if (item.url && item.url.indexOf('/products/' + offerInfo.handle) !== -1) {
        return true;
      }
      
      // Check by product title/name (last resort - less reliable)
      // Only use if handle matches in title
      if (item.product_title && item.product_title.toLowerCase().indexOf('abracs') !== -1) {
        // Additional check - make sure it's the right product
        if (item.url && item.url.indexOf('abhl8150080') !== -1) {
          return true;
        }
      }
    }
    
    return false;
  }
  
  // Count non-offer products in cart
  function countNonOfferProducts(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return 0;
    }
    
    var count = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (!isAnyOfferProduct(cart.items[i])) {
        count += cart.items[i].quantity;
      }
    }
    return count;
  }
  
  // Find offer product line numbers in cart
  function findOfferProductLines(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return [];
    }
    
    var lines = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (isAnyOfferProduct(cart.items[i])) {
        lines.push(i + 1); // Line numbers are 1-indexed
      }
    }
    return lines;
  }
  
  // Remove offer product from cart if it's the only item left
  function checkAndRemoveOfferProductIfAlone(removedVariantId) {
    // Wait briefly for cart to settle, then enforce (covers alone + below-threshold)
    setTimeout(function() {
      if (window.UnlockOffers && UnlockOffers.enforceThresholds) {
        UnlockOffers.enforceThresholds(function(cart, removed) {
          if (!removed) return;
          if (window.location.pathname === '/cart') {
            if (UnlockOffers.refreshCartPageOffers) UnlockOffers.refreshCartPageOffers(cart);
            try {
              if (sessionStorage.getItem('unlockOfferCartPageReloaded') === '1') {
                sessionStorage.removeItem('unlockOfferCartPageReloaded');
                return;
              }
              sessionStorage.setItem('unlockOfferCartPageReloaded', '1');
            } catch (e) {}
            window.location.reload();
          } else if (theme.cartDrawer && theme.cartDrawer._loadCartAfterUnlockCheck) {
            theme.cartDrawer._loadCartAfterUnlockCheck(cart);
          }
        });
      }
    }, 100);
  }
  
  // Intercept cart drawer item removal
  $(document).on('click', '[data-cart-item-remove]', function(e) {
    var $button = $(this);
    var variantId = $button.attr('data-variant-id') || $button.closest('[data-variant-id]').attr('data-variant-id');
    
    if (variantId) {
      // Get current cart to check if this is offer product
      Shopify.getCart(function(cart) {
        var isRemovingOfferProduct = false;
        if (cart && cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            if (parseInt(cart.items[i].variant_id) === parseInt(variantId) && 
                isAnyOfferProduct(cart.items[i])) {
              isRemovingOfferProduct = true;
              break;
            }
          }
        }
        
        // If removing non-offer product, check if we need to remove offer product too
        if (!isRemovingOfferProduct) {
          // Let the removal happen, then check
          setTimeout(function() {
            checkAndRemoveOfferProductIfAlone(variantId);
          }, 100);
        }
      });
    }
  });
  
  // Intercept cart page item removal - use multiple methods for reliability
  // Method 1: Direct link click interception with capture phase
  if (document.addEventListener) {
    document.addEventListener('click', function(e) {
      // Only handle on cart page
      if (window.location.pathname !== '/cart') {
        return;
      }
      
      var target = e.target;
      var link = null;
      
      // Find the link element (could be the target or parent)
      if (target.hasAttribute && target.hasAttribute('data-cart-remove')) {
        link = target;
      } else if (target.closest) {
        link = target.closest('[data-cart-remove]');
      } else {
        // Fallback for older browsers
        var parent = target.parentElement;
        while (parent && !link) {
          if (parent.hasAttribute && parent.hasAttribute('data-cart-remove')) {
            link = parent;
          }
          parent = parent.parentElement;
        }
      }
      
      if (!link) {
        return;
      }
      
      var href = link.getAttribute('href');
      if (!href || href.indexOf('/cart/change') === -1) {
        return;
      }
      
      // Extract line number from URL
      var match = href.match(/line=(\d+)/);
      if (!match) {
        return;
      }
      
      var lineNumber = parseInt(match[1]);
      if (!getOfferProductInfoList().length) {
        return; // No offer product configured, let normal behavior happen
      }
      
      // Prevent default immediately
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Use jQuery for Shopify.getCart if available, otherwise use fetch
      if (typeof Shopify !== 'undefined' && Shopify.getCart) {
        Shopify.getCart(function(cart) {
          handleCartPageRemoval(cart, lineNumber, href);
        });
      } else {
        // Fallback: fetch cart
        fetch('/cart.js')
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            handleCartPageRemoval(cart, lineNumber, href);
          });
      }
      
      return false;
    }, true); // Use capture phase for early interception
  }
  
  // Method 2: jQuery backup — only for non-ajax href=/cart/change links.
  // Cart page ajax remove uses href="#" and theme.Cart._onRemoveItem (do not intercept).
  $(document).on('click', '[data-cart-remove]', function(e) {
    if (window.location.pathname !== '/cart') {
      return;
    }
    
    var $link = $(this);
    var href = $link.attr('href') || '';
    
    if (!href || href === '#' || href.indexOf('/cart/change') === -1 || !getOfferProductInfoList().length) {
      return;
    }
    
    var match = href.match(/line=(\d+)/);
    if (!match) {
      return;
    }
    
    var lineNumber = parseInt(match[1]);
    
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    Shopify.getCart(function(cart) {
      handleCartPageRemoval(cart, lineNumber, href);
    });
    
    return false;
  });
  
  // Centralized function to handle cart page removal
  function handleCartPageRemoval(cart, lineNumber, originalHref) {
    if (!cart || !cart.items || !cart.items[lineNumber - 1]) {
      // Can't find item, just follow original link
      window.location.href = originalHref;
      return;
    }
    
    var itemToRemove = cart.items[lineNumber - 1];
    var isRemovingOfferProduct = isAnyOfferProduct(itemToRemove);
    
    // If removing offer product, just follow the link normally
    if (isRemovingOfferProduct) {
      window.location.href = originalHref;
      return;
    }
    
    // Removing non-offer product - handle removal manually
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { line: lineNumber, quantity: 0 },
      dataType: 'json',
      success: function(response) {
        // Wait for cart to update, then check if we need to remove offer product
        setTimeout(function() {
          Shopify.getCart(function(updatedCart) {
            if (!updatedCart || !updatedCart.items) {
              window.location.reload();
              return;
            }
            
            // Count non-offer products after removal
            var nonOfferCount = countNonOfferProducts(updatedCart);
            
            // If no non-offer products remain, remove offer product
            if (nonOfferCount === 0) {
              var offerLines = findOfferProductLines(updatedCart);
              
              if (offerLines.length > 0) {
                // Remove all offer product lines
                var removePromises = offerLines.map(function(line) {
                  return $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: { line: line, quantity: 0 },
                    dataType: 'json'
                  });
                });
                
                $.when.apply($, removePromises).done(function() {
                  // Reload page after offer product is removed
                  window.location.reload();
                }).fail(function() {
                  // Even if removal fails, reload to show current state
                  window.location.reload();
                });
              } else {
                // No offer product to remove, just reload
                window.location.reload();
              }
            } else {
              // Other products remain, just reload
              window.location.reload();
            }
          });
        }, 500); // Wait 500ms for cart to update
      },
      error: function(xhr, status, error) {
        console.error('Error removing cart item:', error);
        // On error, just follow the original link
        window.location.href = originalHref;
      }
    });
  }

  // Also intercept quantity changes that result in 0 (removal)
  $(document).on('change', '[data-cart-item-quantity]', function() {
    var $input = $(this);
    var quantity = parseInt($input.val()) || 0;
    var variantId = $input.attr('data-variant-id') || $input.closest('[data-variant-id]').attr('data-variant-id');
    if (quantity === 0 && variantId && getOfferProductInfoList().length) {
      // Get current cart to check if this is offer product
      Shopify.getCart(function(cart) {
        var isRemovingOfferProduct = false;
        if (cart && cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            if (parseInt(cart.items[i].variant_id) === parseInt(variantId) && 
                isAnyOfferProduct(cart.items[i])) {
              isRemovingOfferProduct = true;
              break;
            }
          }
        }
        
        // If removing non-offer product, check if we need to remove offer product too
        if (!isRemovingOfferProduct) {
          // Let the removal happen, then check
          setTimeout(function() {
            checkAndRemoveOfferProductIfAlone(variantId);
          }, 100);
        }
      });
    }
  });
  
  // theme.Cart._createCart already runs enforceThresholds after remove — no extra
  // delayed cart-page check (that added ~700ms + a second AJAX / possible reload).
  
  // Cart drawer qty/remove already runs enforceThresholds via _loadCartAfterUnlockCheck.
  // Skip wrapping _updateItem — extra getCart + delays were slowing every qty change.
  
  // Intercept cart drawer's _renderCart to add success message
  var originalRenderCart = null;
  if (typeof theme !== 'undefined' && theme.CartDrawer && theme.CartDrawer.prototype && theme.CartDrawer.prototype._renderCart) {
    originalRenderCart = theme.CartDrawer.prototype._renderCart;
    theme.CartDrawer.prototype._renderCart = function(cart) {
      var self = this;
      
      if (originalRenderCart) {
        originalRenderCart.call(self, cart);
      }
      
      if (window.UnlockOffers && UnlockOffers.addOfferSuccessMessageToCartDrawer) {
        UnlockOffers.addOfferSuccessMessageToCartDrawer(cart);
      }
    };
  }
  
  // _loadCart already adds success message in theme.js — skip duplicate intercept
  
  // Safety check: On cart page load, enforce unlock thresholds + alone-offer cleanup
  function checkCartOnPageLoad() {
    if (window.location.pathname !== '/cart') {
      return;
    }

    // Prevent reload loops if a prior pass already refreshed this tab session
    try {
      if (sessionStorage.getItem('unlockOfferCartPageReloaded') === '1') {
        sessionStorage.removeItem('unlockOfferCartPageReloaded');
        return;
      }
    } catch (e) {}

    function reloadCartPageOnce() {
      try {
        sessionStorage.setItem('unlockOfferCartPageReloaded', '1');
      } catch (err) {}
      window.location.reload();
    }

    if (window.UnlockOffers && typeof UnlockOffers.enforceThresholds === 'function') {
      UnlockOffers.enforceThresholds(function(cart, removed) {
        if (removed) {
          if (UnlockOffers.refreshCartPageOffers) {
            UnlockOffers.refreshCartPageOffers(cart);
          }
          reloadCartPageOnce();
          return;
        }
        // Also remove unlock products if they are the only items left
        if (!getOfferProductInfoList().length) return;
        if (!cart || !cart.items || cart.items.length === 0) return;
        var nonOfferCount = countNonOfferProducts(cart);
        if (nonOfferCount === 0) {
          var offerLines = findOfferProductLines(cart);
          if (offerLines.length > 0) {
            var updates = {};
            cart.items.forEach(function(item) {
              if (isAnyOfferProduct(item)) updates[item.key] = 0;
            });
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              dataType: 'json',
              data: { updates: updates }
            }).always(function() {
              reloadCartPageOnce();
            });
          }
        }
      });
      return;
    }

    if (!getOfferProductInfoList().length) {
      return;
    }
    
    Shopify.getCart(function(cart) {
      if (!cart || !cart.items || cart.items.length === 0) {
        return;
      }
      
      var nonOfferCount = countNonOfferProducts(cart);
      
      if (nonOfferCount === 0) {
        var offerLines = findOfferProductLines(cart);
        
        if (offerLines.length > 0) {
          var removePromises = offerLines.map(function(line) {
            return $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: { line: line, quantity: 0 },
              dataType: 'json'
            });
          });
          
          $.when.apply($, removePromises).done(function() {
            reloadCartPageOnce();
          }).fail(function() {
            reloadCartPageOnce();
          });
        }
      }
    });
  }
  
  // Run check when cart page loads
  if (window.location.pathname === '/cart') {
    if (typeof jQuery !== 'undefined' && typeof Shopify !== 'undefined') {
      $(document).ready(function() {
        setTimeout(checkCartOnPageLoad, 100);
      });
    } else {
      window.addEventListener('load', function() {
        setTimeout(checkCartOnPageLoad, 200);
      });
    }
  }
})();
